import moment from "moment-timezone";
import "moment/locale/es-mx";
moment.locale("es-mx");

const useFormatDate = () => {
    const timezone = moment.tz.guess();
    const formatDate = (date, format) => moment.tz(date, timezone).format(format);
    return { formatDate }
}

export default useFormatDate